export default __webpack_public_path__ + "static/media/new.430b2ce9.svg";